import { $Q, $Qll } from "../utils/query-selector"
import { dataToggle } from "../utils/toggle-dataset";

/**
 * It executes the action on dataset when a tab is clicked
 * @param {HTMLCollection} sliderTabsItems : The elements inside slider tabs
 * @param {HTMLElement} item : The element clicked
 */
const dispatchTabAction = (sliderTabsItems, item) => {
  const active = item.dataset.active ;

  if(active === "false") {
    sliderTabsItems.forEach((element, index) => {
      dataToggle(element);
      dataToggle($Qll(`.slider-container .slider-wrapper`)[index]);
    })
  }
}

/**
 * It handles slider tabs items click
 * @param {HTMLCollection} sliderTabsItems : The elements inside slider tabs
 */
const handleClickTab = (sliderTabsItems) => {
  sliderTabsItems.forEach(item => {
    item.addEventListener("click", () => {
      dispatchTabAction(sliderTabsItems, item);
    })
  });
}

/* It initializes slider tabs on homepage */
export const initSliderTabs = () => {
  const sliderContainer = $Q(".slider-container");

  if(!sliderContainer) return;

  handleClickTab($Qll(".slider-tabs__item"));
}
